<script>
export const group = 'Full'
</script>

<script setup>
import { ref, nextTick } from 'vue'
import Image from '../default/Image.vue'
import Transition4 from './transitions/Transition4.vue'

defineProps({
  item: Object,
})

const transition = ref(null)

const startTransition = async () => {
  await nextTick()
  if (transition.value) {
    transition.value.start()
  }
}
</script>

<template>
  <Transition4 ref="transition" :manualStart="true">
    <Image :item="item" @load="startTransition" />
  </Transition4>
</template>
